<template>
  <div class="grid-container fluid mayor ptxl pbxl">
    <div class="grid-x grid-container">
      <div class="cell large-12 small-24">
        <div class="image-container">
          <img
            src="https://www.phila.gov/assets/images/website/mayor.png"
            alt="Cherelle L. Parker headshot"
          >
        </div>
      </div>
      <div class="cell large-10 small-24 mayor-text">
        <h2 class="title">
          Mayor <br> Cherelle L. Parker
        </h2>
        <div class="subtitle">
          {{ $t("mayor.mayor-details") }}
        </div>
        <div class="ptl">
          <a
            class="button content-type-mayor"
            href="https://www.phila.gov/departments/mayor/"
          >
            Learn more
            <i
              class="fas fa-angle-right fa-lg"
              aria-hidden="true"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
